
const css = ".styles-module__container___w8eAF {\n  display: flex;\n  align-items: center;\n  height: 24px;\n}\n\n.styles-module__label___J5mxE {\n  padding-inline: 8px 2px;\n  line-height: 20px;\n  font-size: 13px;\n  letter-spacing: -0.15px;\n  color: rgba(26, 26, 26, 0.5);\n  cursor: pointer;\n}\n[data-agentation-theme=dark] .styles-module__label___J5mxE {\n  color: rgba(255, 255, 255, 0.5);\n}";
const classNames = {"container":"styles-module__container___w8eAF","label":"styles-module__label___J5mxE"};

// SSR-safe style injection (always update for HMR)
if (typeof document !== 'undefined') {
  let style = document.getElementById('feedback-tool-styles-checkbox-field-styles');
  if (!style) {
    style = document.createElement('style');
    style.id = 'feedback-tool-styles-checkbox-field-styles';
    document.head.appendChild(style);
  }
  style.textContent = css;
}

export default classNames;
